export default class ErrorAlert {

    public static alert(error: any) {
        alert(error.response.data.message);
    }
}